var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-box loader-box__large"},[_c('div',{staticClass:"loader-37"})])
}]

export { render, staticRenderFns }